import { useIntl } from 'react-intl'
import styled from 'styled-components'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import LineKidIcon from 'LuxKit/Icons/line/LineKidIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { KIDS_FLY_FREE_COLOUR } from 'constants/charterFlight'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'

const KidsFlyFreeColour = styled.div`
  color: ${KIDS_FLY_FREE_COLOUR};
`

interface Props {
  variant?: 'full' | 'short'
}

function KidsFlyFreeLabel({ variant = 'full' }: Props) {
  const intl = useIntl()
  const childrenFlyFreeEnabled = useFeatureFlag(OptimizelyFeatureFlags.childrenFlyFree)

  if (!childrenFlyFreeEnabled) return null

  if (variant === 'short') {
    return (
      <KidsFlyFreeColour>
        <Group direction="horizontal" verticalAlign="center" gap={4}>
          <LineKidIcon size="XS" />
          <BodyText variant="small">{intl.formatMessage({
            id: 'bdFgo8a0KBXCTZiQrQ44',
            defaultMessage: 'Kids fly free',
          })}
          </BodyText>
        </Group>
      </KidsFlyFreeColour>
    )
  }

  return (
    <StructureLabel
      variant="standard"
      startIcon={<LineKidIcon />}
    >
      {intl.formatMessage({
        id: 'MGt7Zh13HJSG1hCiJJZR',
        defaultMessage: 'Kids fly free on select dates',
      })}
    </StructureLabel>
  )
}

export default KidsFlyFreeLabel
